var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`flag-header flag-icon-background flag-icon-${_vm.country.toLowerCase()}`})
}
var staticRenderFns = []

export { render, staticRenderFns }